<app-breadcrumb *ngIf="!template" master="Administracja" parentName="Szablony" name="Dodaj"></app-breadcrumb>
<div class="template-add" fxLayout="column" fxLayoutGap="15px" [formGroup]="templateForm">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!templateFormValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Dane szablonu</h3>
            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <ngx-mat-file-input
                  placeholder="Wybierz plik (*.pdf, *.docx, *.xlsx, {{fileMaxSize | byteFormat}})"
                  [required]="!template"
                  [multiple]="true"
                  accept=".docx,.xlsx,.pdf"
                  formControlName="file"
                ></ngx-mat-file-input>
                <mat-icon matSuffix color="accent">attachment</mat-icon>
                <mat-error *ngIf="templateForm.get('file').hasError('required')">Wybierz plik</mat-error>
                <mat-error *ngIf="templateForm.get('file').hasError('maxContentSize')">
                  Całkowity rozmiar pliku nie może przekraczać
                  {{templateForm.get('fileContent').getError('maxContentSize').maxSize | byteFormat}}
                  (Wybrany plik: {{templateForm.get('file').getError('maxContentSize').actualSize
                  | byteFormat}}).
                </mat-error>
              </mat-form-field>
            </div>

            <div fxLayout="row">
              <mat-form-field fxFlex="100">
                <mat-label>Nazwa</mat-label>
                <input matInput placeholder="Szablon.xlsx" formControlName="name" [required]="true">
                <mat-error *ngIf="templateForm.get('name').hasError('required')">To pole jest wymagane</mat-error>
              </mat-form-field>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" dictType="template_type" label="Typ szablonu"
                        [required]="true" [control]="templateTypeControl"></app-dict>
            </div>

            <div fxLayout="row" *ngIf="validFromControl.enabled">
              <app-datepicker
                fxFlex="100"
                label="Obowiązuje od"
                placeholder="2000-01-01"
                [required]="true"
                [control]="validFromControl"
              ></app-datepicker>
            </div>

          </mat-card>
        </div>
      </div>
    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requireContractDataFields">
        <div fxFlex="100">
          <mat-card fxLayout="column" fxLayoutGap="15px">

            <div fxLayout="row">
              <h3>Dane umowy</h3>
            </div>

            <div fxLayout="row">
              <mat-slide-toggle fxFlex="100" color="accent" formControlName="annex">Aneks</mat-slide-toggle>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" dictType="contract_type" label="Typ umowy"
                        [required]="true" [control]="contractTypeControl"></app-dict>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" dictType="company" label="Firma"
                        [required]="true" [control]="companyControl"></app-dict>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" dictType="contract_owner" label="Strona umowy"
                        [required]="true" [control]="ownerControl"></app-dict>
            </div>

            <div fxLayout="row" *ngIf="requireLegalForm">
              <app-dict fxFlex="100" dictType="legal_form" label="Forma prawna"
                        [required]="true" [control]="legalFormControl"></app-dict>
            </div>

            <div fxLayout="row" *ngIf="requireTerminationTypeDataFields">
              <app-dict fxFlex="100" dictType="termination_type" label="Sposób rozwiązania"
                        [required]="true" [control]="terminationTypeControl"></app-dict>
            </div>

            <div fxFlex="100" *ngIf="requireLegalForm && !legalFormLegal && !requireTerminationTypeDataFields">
              <app-dict class="partners-add-input" [label]="'Typ działalności'" [dictType]="'form_of_business'"
                        [onlyKeys]="[FORM_OF_BUSINESS_SOLE_PROPRIETORSHIP, FORM_OF_BUSINESS_NONE_PROPRIETORSHIP]"
                        [control]="formOfBusinessControl" [required]="true"></app-dict>
            </div>
            <div fxFlex="50" *ngIf="requireLegalForm && legalFormLegal && !requireTerminationTypeDataFields">
              <app-dict class="partners-add-input" [label]="'Typ działalności'" [dictType]="'form_of_business'"
                        [onlyKeys]="FORM_OF_BUSINESS_LEGAL_PERSON" [control]="formOfBusinessControl" [required]="true"></app-dict>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requireContractAnnexDataFields">
        <div fxFlex="100">
          <mat-card fxLayout="column" fxLayoutGap="15px">

            <div fxLayout="row">
              <h3>Dane umowy</h3>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" dictType="contract_type" label="Typ umowy"
                        [required]="true" [control]="contractTypeControl"></app-dict>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" dictType="company" label="Firma"
                        [required]="true" [control]="companyControl"></app-dict>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" dictType="contract_owner" label="Strona umowy"
                        [required]="true" [control]="ownerControl"></app-dict>
            </div>

            <div fxLayout="row" *ngIf="requireLegalForm">
              <app-dict fxFlex="100" dictType="legal_form" label="Forma prawna"
                        [required]="true" [control]="legalFormControl"></app-dict>
            </div>

            <div fxLayout="row" *ngIf="requireTerminationTypeDataFields ">
              <app-dict fxFlex="100" dictType="termination_type" label="Sposób rozwiązania"
                        [required]="true" [control]="terminationTypeControl"></app-dict>
            </div>


            <div fxFlex="100" *ngIf="requireLegalForm && !legalFormLegal && !requireTerminationTypeDataFields">
              <app-dict class="partners-add-input" [label]="'Typ działalności'" [dictType]="'form_of_business'"
                        [onlyKeys]="[FORM_OF_BUSINESS_SOLE_PROPRIETORSHIP, FORM_OF_BUSINESS_NONE_PROPRIETORSHIP]"
                        [control]="formOfBusinessControl" [required]="true"></app-dict>
            </div>
            <div fxFlex="50" *ngIf="requireLegalForm && legalFormLegal && !requireTerminationTypeDataFields">
              <app-dict class="partners-add-input" [label]="'Typ działalności'" [dictType]="'form_of_business'"
                        [onlyKeys]="FORM_OF_BUSINESS_LEGAL_PERSON" [control]="formOfBusinessControl" [required]="true"></app-dict>
            </div>


          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requireRegistrationDataFields ">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Dane rejestracji</h3>
            </div>

            <div fxLayout="row">
              <app-dict-insurance-companies fxFlex="100" label="TU" [required]="true" [control]="insuranceCompanyControl"></app-dict-insurance-companies>
            </div>

            <div fxLayout="row">
              <app-dict label="Firma" dictType="company" [multiple]="true" [control]="companiesControl" fxFlex="100" [required]="true"></app-dict>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" dictType="contract_type" label="Typ umowy"
                        [required]="false" [control]="contractTypeControl"></app-dict>
            </div>
          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="  requireFileConfigurationDataFields">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Dane rejestracji</h3>
            </div>

            <div fxLayout="row">
              <app-dict-insurance-companies fxFlex="100" label="TU" [required]="true" [control]="insuranceCompanyControl"></app-dict-insurance-companies>
            </div>

            <div fxLayout="row">
              <app-dict label="Firma" dictType="company" [multiple]="false" [control]="companyControl" fxFlex="100" [required]="true"></app-dict>
            </div>

          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requireAuthorizationDataFields">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Dane rejestracji</h3>
            </div>

            <div fxLayout="row">
              <app-dict-insurance-companies fxFlex="100" label="TU" [required]="true" [control]="insuranceCompanyControl"></app-dict-insurance-companies>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" dictType="company" label="Firma"
                        [required]="true" [control]="companyControl"></app-dict>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" dictType="contract_type" label="Typ umowy"
                        [required]="false" [control]="contractTypeControl"></app-dict>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requirePersonalDataChange">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Dane rejestracji</h3>
            </div>

            <div fxLayout="row">
              <app-dict-insurance-companies fxFlex="100" label="TU" [required]="true" [control]="insuranceCompanyControl"></app-dict-insurance-companies>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" dictType="company" label="Firma"
                        [required]="true" [control]="companyControl"></app-dict>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requirePartnerDataFields">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Dane Partnera</h3>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" dictType="legal_form" label="Forma prawna"
                        [required]="true" [control]="legalFormControl"></app-dict>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="requireOfwcaApplicationDataFields">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Dane zgłoszenia</h3>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" dictType="company" label="Firma"
                        [required]="true" [control]="companyControl"></app-dict>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%"  *ngIf="requireFileConfigurationDataFields">
        <div fxFlex="100">
          <mat-card>

            <div fxLayout="row">
              <h3>Konfiguracja pliku</h3>
            </div>

            <div fxLayout="row">
              <app-dict fxFlex="100" [multiple]="false"  dictType="file_extension" label="Typ pliku" [required]="true" [control]="fileExtensionControl"></app-dict>
            </div>


            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100" >
                <table fxFlex="100">
                  <tr *ngFor="let sortItem of sortItems">
                    <td *ngFor="let item of sortItem"  fxFlex="50" >
                      <mat-checkbox *ngIf="item.key !== GENERATED_FIELDS_SEPARATOR && item.key !== GENERATED_EMPTY"
                        (change)="add(item)"
                        [checked]="isSelect(item.key)">
                        {{item.name}}
                      </mat-checkbox>
                      <button class="separator" (click)="add(item)" *ngIf="item.key === GENERATED_FIELDS_SEPARATOR && !startingFieldDataFields"> {{item.name}}</button>
                      <button class="reset" (click)="resetForm()" *ngIf="item.key === GENERATED_FIELDS_SEPARATOR"> Wyczyść </button>
                      <button class="separator" (click)="add(item)" *ngIf="item.key === GENERATED_EMPTY && !startingFieldDataFields"> {{item.name}} </button>
                    </td>
                  </tr>
                  <tr>
                    <td> <h4> Lista pól: </h4>  </td>
                  </tr>
                  <tr>
                    <td> {{'${lista wyrejestrowań}'}}  </td>
                  </tr>

                  <tr>
                    <td> <h4> Kolejność Kolumn: </h4>  </td>
                  </tr>

                  <tr>
                    <ol style="line-height: 130%">
                      <li *ngFor="let item of selectedValuesName">
                        {{item}}
                      </li>
                    </ol>
                  </tr>

                </table>
              </div>
            </div>
<br>
            <div fxLayout="row"   *ngIf="startingFieldDataFields">
              <div fxFlex="100"  fxLayoutGap="15px">
                <mat-form-field fxFlex="50">
                  <mat-label>Pozycja startowa Wiersza  </mat-label>
                  <input  type="number"  min="1" [required]="true" matInput  placeholder="1"formControlName="startingFieldX">
                </mat-form-field>

                <mat-form-field fxFlex="50">
                  <mat-label>Pozycja startowa Kolumny </mat-label>
                  <input  type="number"  min="1" [required]="true" matInput  placeholder="1" formControlName="startingFieldY">
                </mat-form-field>
              </div>

            </div>


          </mat-card>
        </div>
      </div>

    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!templateFormValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
